import React, {useState, useEffect} from "react"
import PartFourLanding from "./PartFourLanding"
import FourJokers from "./FourJokers"
import Science from "./Science"

function PartFour(props) {
    const [puzzleCompleted, setPuzzleCompleted] = useState({
        decoder: false, 
        speakToJack: false,
        memoryGame: false,
        memoryGameReward: false,
        science: false
    })
    const [startCountdown, setStartCountdown] = useState(false) 
    const [partFourContent, setPartFourContent] = useState("")
    
    if (props.partStatus === "complete" && !puzzleCompleted.decoder) {
        setPuzzleCompleted({
            decoder: true, 
            speakToJack: true,
            memoryGame: true,
            memoryGameReward: true,
            science: true
        })
    }
    
    useEffect(() => {
        if (props.barClicked) {
            setPuzzleCompleted({
                ...puzzleCompleted,
                decoder: true
            })
            
            props.callBackRevealClues("Jack's Game", "The Coded Letter")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.barClicked])
        
    useEffect(() => {
        if (puzzleCompleted.memoryGameReward) {
            setPartFourContent( <Science callBackKeypad={props.callBackKeypad}/> )
        } else if (puzzleCompleted.decoder) {
            setPartFourContent( <FourJokers puzzleCompleted={puzzleCompleted} playJack={playJack} startCountdown={startCountdown} callBackMemory={callBackMemory} goToScience={goToScience} timeLimit={props.timeLimit} /> )
        } else if (!puzzleCompleted.decoder){
            setPartFourContent ( <PartFourLanding /> )                        
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [puzzleCompleted, props.timeLimit])
        
    function playJack() {
        document.getElementById("jackRecording").play()
        setTimeout(() => progressToGame(), 24000) //24000
    }

    function progressToGame() {
//        document.getElementById("fourJokersWrapper").style.minHeight = "70vw"
        setTimeout(() => setStartCountdown(true), 1000);
        setTimeout(() => setPuzzleCompleted({...puzzleCompleted, speakToJack: true}), 1000);
    }
    
    function callBackMemory() {
        setPuzzleCompleted({
            ...puzzleCompleted,
            memoryGame: true
        })
        props.callBackGameUpdate()
    }
    
    function goToScience() {
        setPuzzleCompleted({
            ...puzzleCompleted,
            memoryGameReward: true
        })
        props.callBackRevealClues("The Temperature", "Jack's Game")
    }
          
    return (
        <div>    
            {partFourContent}
        </div>
    )
}

export default PartFour